import React, { useState } from "react";
import { Header } from "../components/Header";
import { Modal } from "../components/Modal";
import { IoMdClose } from "react-icons/io";

export const YogeshwariAarti = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [modalTitle, setModalTitle] = useState("");

  const aartiData = [
    {
      title: "आरती योगेश्वरीची ",
      img: "/other_imgs/thumbnail-aarti-noBg.png",
      url: "https://www.youtube.com/embed/BrGkMcNDGlo",
    },
    {
      title: "बोडणाची आरती",
      img: "/other_imgs/thumbnail-aarti-noBg.png",
      url: "https://www.youtube.com/embed/owTQK2W1D2Q",
    },
    {
      title: "धन्य अंबापूर",
      img: "/other_imgs/thumbnail-aarti-noBg.png",
      url: "https://www.youtube.com/embed/LYEiEP2YVCE",
    },
    {
      title: "आरती जगदंबेची",
      img: "/other_imgs/thumbnail-aarti-noBg.png",
      url: "https://www.youtube.com/embed/M-QXEVbUCjI",
    },
    {
      title: "जयजय अष्टभुजे",
      img: "/other_imgs/thumbnail-aarti-noBg.png",
      url: "https://www.youtube.com/embed/ZguPxKmAZuI",
    },
    {
      title: "जयदेव जयदेव",
      img: "/other_imgs/thumbnail-aarti-noBg.png",
      url: "https://www.youtube.com/embed/sZX_fEU9MOI",
    },
  ];

  const openModal = (url, title) => {
    if (url) {
      setVideoUrl(url);
      setModalTitle(title);
      setModalOpen(true);
    } else {
      alert("Video not available");
    }
  };

  const closeModal = () => {
    setModalOpen(false);
    setVideoUrl("");
    setModalTitle("");
  };

  return (
    <>
      <div className="w-full flex flex-col items-center justify-center">
        <Header />
        <img
          src="/other_imgs/banner-dharmik-aarti-inside.jpg"
          alt="Information Banner"
          className="w-full shadow-lg"
        />
      </div>

      {/* Grid Section */}
      <ul className="grid gap-4 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 mb-10 mx-4 sm:mx-10 md:mx-20">
        {aartiData.map((aarti, index) => (
          <li
            key={index}
            className="flex items-center border-2 mt-6 bg-yellow-500  shadow-lg rounded-lg p-4 sm:p-6 
                         h-[130px] w-full max-w-[550px] mx-auto hover:scale-105 transition-all duration-300"
            onClick={() => openModal(aarti.url, aarti.title)}
          >
            <div className="flex items-center w-full cursor-pointer">
              <img
                src={aarti.img}
                alt={aarti.title}
                className="w-20 h-20 sm:w-28 sm:h-28 object-cover rounded-md mr-4 sm:mr-10"
              />
              <div className="text-base sm:text-lg font-semibold text-maroon">
                {aarti.title}
              </div>
            </div>
          </li>
        ))}
      </ul>

      {/* Modal */}
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <div className="relative w-full h-full p-4 sm:p-6 bg-white rounded-lg">
          <button
            className="absolute top-2 right-2 text-gray-700 rounded-full p-2 shadow-md"
            onClick={closeModal}
          >
            <IoMdClose />
          </button>
          <h2 className="text-center text-xl sm:text-2xl font-bold text-red-600 mb-4">
            {modalTitle}
          </h2>
          {videoUrl ? (
            <iframe
              width="100%"
              height="250"
              className="sm:h-[350px] rounded-lg"
              src={videoUrl}
              title="YouTube video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          ) : (
            <div className="text-center text-lg font-semibold">
              Video not available
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};
